import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import cx from 'classnames';
import AddButton from '../../common/buttons/buttonLink';
import AdminAddButton from '../../admin/shared/Buttons/AdminAddButton';
import AddAppointmentsButton from '../../common/buttons/addAppointmentsButton';
import {
  canUserBookAppointments,
  canUserAddCustomers,
  canUserModifyBarbers,
} from '../../common/helpers/users';
import { containerApp } from '../../../main';
import { getIsAdminRole } from '../../auth/selectors';

class Header extends Component {
  openSidebar = () => {
    this.context.toggleSidebar(true);
  }

  render() {
    const {
      button,
      type,
      link,
      heading,
      children,
      barberUser,
      isAdminUser,
      permissions,
      dropdown,
      className,
    } = this.props;
    const hasButton = !!button; // strict true or false
    let headerButton = null;

    let data;
    if (barberUser) {
      data = {
        barberId: get(this.props, 'barberUser.id'),
      };
    }

    const setHeaderButton = () => {
      headerButton = isAdminUser ? (<AdminAddButton
        content={button}
        link={link}
        inHeader
      />) : (<AddButton
        content={button}
        link={link}
        inHeader
      />);
    };

    if (hasButton) {
      switch (type) {
        case 'user':
        case 'shop':
        case 'brand':
          if (isAdminUser) {
            headerButton = (
              <AdminAddButton
                content={button}
                link={link}
                inHeader
              />
            );
          }
          break;
        case 'appointment':
          if (canUserBookAppointments(permissions)) {
            headerButton = (
              <AddAppointmentsButton
                content={button}
                data={data}
                inHeader
              />
            );
          }
          break;
        case 'client':
          if (canUserAddCustomers(permissions)) {
            setHeaderButton();
          }
          break;
        case 'customer':
          if (canUserAddCustomers(permissions)) {
            setHeaderButton();
          }
          break;
        case 'barber':
          if (canUserModifyBarbers(permissions)) {
            setHeaderButton();
          }
          break;
        default:
      }
    }

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <header className={cx('c-header-primary c-header-primary--inner-page js-header', className)}>
        <div
          className="c-header-primary__item u-position-relative u-ph u-pv- u-visible-for-extralarge-and-up"
          display-if={!containerApp.isActive()}
        >
          <div className="c-heading c-heading--dark c-heading--main-header" data-automation-id="text:header">
            {heading}
          </div>
        </div>
        <div
          className="c-hamburger"
          onClick={this.openSidebar}
          display-if={!containerApp.isActive()}
        >
          <div className="c-header-primary__item"><span className="c-mobile-nav" /></div>
        </div>
        {children}
        {headerButton}
        {dropdown}
      </header>
    );
  }
}

Header.propTypes = {
  button: PropTypes.string,
  type: PropTypes.oneOf(['user', 'shop', 'brand', 'appointment', 'client', 'customer', 'barber', 'link']),
  link: PropTypes.string, // eslint-disable-line
  heading: PropTypes.string, // eslint-disable-line
  children: PropTypes.node, // eslint-disable-line
  barberUser: PropTypes.object, // eslint-disable-line
  permissions: PropTypes.object.isRequired, // eslint-disable-line
  dropdown: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
  className: PropTypes.string,
  isAdminUser: PropTypes.bool.isRequired,
};

Header.defaultProps = {
  type: 'link',
  button: false,
  dropdown: null,
  className: '',
};
Header.contextTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
  permissions: state.auth.permissions,
  isAdminUser: getIsAdminRole(state),
});

export default connect(mapStateToProps, null)(Header);
